import React, { Component } from "react";

/**
 * GlobalDataTable - A reusable table component with inline styles
 *
 * @prop {Array<Object>} data - Array of row data objects
 * @prop {Array<Object>} columns - Column configuration array
 * @prop {Array<Object>} groupHeaders - Group header configuration (optional)
 * @prop {Object} tableStyle - Custom table container styles (optional)
 * @prop {function} getRowStyle - Function to get custom row styles (row, index) => object (optional)
 */
const styles = {
  container: {
    backgroundColor: "#f5f5f5",
  },
  wrapper: {
    maxWidth: "1400px",
    margin: "0 auto",
  },
  tableContainer: {
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  thGroup: {
    border: "1px solid #e5e7eb",
    padding: "15px",
    textAlign: "center",
    fontWeight: "600",
    fontSize: "14px",
    color: "#374151",
  },
  th: {
    border: "1px solid #e5e7eb",
    padding: "16px",
    textAlign: "center",
    fontWeight: "500",
    fontSize: "14px",
    color: "#6b7280",
    minWidth: "60px",
  },
  td: {
    border: "1px solid #e5e7eb",
    padding: "10px",
    textAlign: "center",
    fontSize: "14px",
    color: "#374151",
  },
  rowEven: {
    backgroundColor: "white",
  },
  rowOdd: {
    backgroundColor: "#fafafa",
  },
};

export default class SimpleMultiHeaderTable extends Component {
  renderCell = (column, value, row) => {
    if (column.render) {
      return column.render(value, row);
    }
    return value;
  };

  render() {
    const {
      data = [],
      columns = [],
      groupHeaders = [],
      tableStyle = {},
      getRowStyle,
    } = this.props;

    return (
      <div className="table-container-wrapper">
        <div className="table-content-wrapper">
          <div className="table-container" style={tableStyle}>
            <div className="table-wrapper">
              <table className="simple-group-table">
                <thead>
                  {groupHeaders.length > 0 && (
                    <tr>
                      {groupHeaders.map((header, index) => (
                        <th
                          key={index}
                          colSpan={header.colSpan || 1}
                          rowSpan={header.rowSpan || 1}
                          className="th-group"
                          style={header.style}
                        >
                          {header.label}
                        </th>
                      ))}
                    </tr>
                  )}
                  <tr>
                    {columns.map((column, index) => {
                      return (
                      <th
                        key={index}
                        className="th-sub"
                        style={column.headerStyle}
                      >
                        {column.label}
                      </th>
                    )
                    })}
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td
                        colSpan={columns.length}
                        className="table-empty-state"
                      >
                        Sorry, no matching records found
                      </td>
                    </tr>
                  ) : (
                    data.map((row, rowIndex) => {
                      const customRowStyle = getRowStyle
                        ? getRowStyle(row, rowIndex)
                        : {};
                      const rowClass =
                        rowIndex % 2 === 0 ? "row-even" : "row-odd";

                      return (
                        <tr
                          key={rowIndex}
                          className={rowClass}
                          style={customRowStyle}
                        >
                          {columns.map((column, colIndex) => {
                            const value = row[column.key];
                            return (
                              <td key={colIndex} style={column.cellStyle}>
                                {this.renderCell(column, value, row)}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
